module.exports = __webpack_public_path__ + "img/completed.5f343572.svg";